import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { OfacFilesTable } from '../../../../../../../../../../features/watchlist/ofac/file/ofac-files-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/file/_file/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingComplianceOfac,
      label: 'Files',
      order: 2,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingComplianceOfac>,
  head: () => getPageHead('OFAC Files'),
  component: OfacFileList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingComplianceOfac}
    />
  );
}

function OfacFileList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <OfacFilesTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
